import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1mv0spc-0"
})(function (_ref) {
  var $backgroundColor = _ref.$backgroundColor;
  return css(["width:100%;max-width:", ";overflow:hidden;background-color:", ";cursor:pointer;"], space(50), $backgroundColor);
});
export var BackTile = styled.div.withConfig({
  componentId: "sc-1mv0spc-1"
})(function (_ref2) {
  var $backgroundColor = _ref2.$backgroundColor,
    $hasImageStuckToRight = _ref2.$hasImageStuckToRight,
    theme = _ref2.theme;
  return css(["display:flex;justify-content:", ";overflow:hidden;border-radius:", ";background:", ";", "{justify-content:flex-end;}"], $hasImageStuckToRight ? "flex-end" : "center", getBorderRadius(theme, "xlarge"), $backgroundColor, breakpoint("small", "medium"));
});
export var ImageWrapper = styled.div.withConfig({
  componentId: "sc-1mv0spc-2"
})(["max-width:", ";max-height:", ";"], unit(328), unit(288));
export var FrontTile = styled.div.withConfig({
  componentId: "sc-1mv0spc-3"
})(["position:relative;margin-top:", ";margin-right:", ";margin-left:", ";padding:", ";border-top:", " solid rgba(255,255,255,0.12);border-left:", " solid rgba(255,255,255,0.12);border-radius:", ";backdrop-filter:blur(", ");-webkit-backdrop-filter:blur(", ");background:rgba(0,0,0,0.12);", "{margin-top:", ";}", "{padding:", ";}"], space(-12.5), space(2), space(2), space(3), unit(1), unit(1), space(5), space(7.5), space(7.5), breakpoint("small", "medium"), space(-10), breakpoint("medium"), space(4));
export var Button = styled.button.withConfig({
  componentId: "sc-1mv0spc-4"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["display:flex;position:relative;align-items:center;justify-content:center;width:", ";height:", ";padding:", ";border:", " solid ", ";border-radius:", ";background:", ";&:hover{background:", ";}"], unit(44), unit(44), space(1.5), unit(1), getColor(theme, "white"), unit(20), getColor(theme, "white"), getColor(theme, "white"));
});
export var ButtonWrapper = styled.div.withConfig({
  componentId: "sc-1mv0spc-5"
})(function (_ref4) {
  var $backgroundColor = _ref4.$backgroundColor,
    theme = _ref4.theme;
  return css(["position:absolute;right:0;bottom:0;padding-top:", ";padding-left:", ";border-top-left-radius:", ";background-color:", ";box-shadow:", " ", " ", ";"], unit(12), unit(12), getBorderRadius(theme, "xlarge"), $backgroundColor, unit(1), unit(1), $backgroundColor);
});
export var Icon = styled.span.withConfig({
  componentId: "sc-1mv0spc-6"
})(["", "{transform:rotate(-45deg);}"], breakpoint("small", "medium"));
export var BottomRoundedCorner = styled.div.withConfig({
  componentId: "sc-1mv0spc-7"
})(function (_ref5) {
  var $size = _ref5.$size,
    $backgroundColor = _ref5.$backgroundColor;
  return css(["position:absolute;bottom:0;left:", ";width:", ";height:", ";box-shadow:", " ", " ", ";"], unit(-1 * $size), unit($size), unit($size), unit(1), unit(1), $backgroundColor);
});
export var TopRoundedCorner = styled.div.withConfig({
  componentId: "sc-1mv0spc-8"
})(function (_ref6) {
  var $size = _ref6.$size,
    $backgroundColor = _ref6.$backgroundColor;
  return css(["position:absolute;top:", ";right:0;width:", ";height:", ";box-shadow:", " ", " ", ";"], unit(-1 * $size), unit($size), unit($size), unit(1), unit(1), $backgroundColor);
});